import { render, staticRenderFns } from "./PrivacyContent.vue?vue&type=template&id=2984cfdf&scoped=true&"
var script = {}
import style0 from "./PrivacyContent.vue?vue&type=style&index=0&id=2984cfdf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2984cfdf",
  null
  
)

export default component.exports